import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["type", "onClick"]

import { computed, useAttrs } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppTab',
  props: {
    items: {},
    modelValue: {},
    itemClass: { default: "" },
    activeClass: { default: "app-tab--active" },
    columns: { default: undefined },
    type: { default: "button" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const attrs = useAttrs();

const wrapperClass = computed(() => ["app-tabs", attrs.class as any]);
const wrapperStyle = computed(() => ({
  "--app-tabs-columns": String(props.columns || props.items.length || 1),
}));

function getItemClass(value: string) {
  return [
    "app-tab",
    props.itemClass,
    props.modelValue === value ? props.activeClass : null,
  ];
}

const wrapperAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});

function handleSelect(value: string) {
  emit("update:modelValue", value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: wrapperClass.value,
    style: wrapperStyle.value
  }, wrapperAttrs.value), [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item.value,
        type: __props.type,
        class: _normalizeClass(getItemClass(item.value)),
        onClick: ($event: any) => (handleSelect(item.value))
      }, _toDisplayString(item.label), 11, _hoisted_1))
    }), 128))
  ], 16))
}
}

})